/**
 * Demo mode price utilities.
 *
 * When VITE_DEMO_MODE is "true", all prices are hidden from the admin UI
 * and replaced with a placeholder. Useful for demos where real pricing
 * data should not be visible.
 */

export const isDemoMode: boolean =
  import.meta.env.VITE_DEMO_MODE === 'true';

/**
 * Format a price in cents as currency, or return a placeholder in demo mode.
 *
 * @param priceCents - Price in cents (integer)
 * @param currency   - ISO 4217 currency code (defaults to 'EUR')
 * @returns Formatted currency string, or "—" when in demo mode
 */
export const formatPrice = (
  priceCents: number | null | undefined,
  currency: string = 'EUR',
): string => {
  if (isDemoMode) return '—';
  if (priceCents == null) return 'N/A';

  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: currency || 'EUR',
  }).format(priceCents / 100);
};
